/**
 * InfoHubScreen — hub unico per informazioni e sicurezza (route /info-hub).
 * Raggruppa le tre schermate informative in un solo punto, così nel menu inbox
 * c'è una sola voce "Info & sicurezza" invece di tre.
 */

import { useNavigate } from 'react-router-dom';
import { Frame, Header, Footer, Btn } from '../components/Frame';
import { CardLink } from '../components/Section';

export default function InfoHubScreen() {
  const navigate = useNavigate();
  return (
    <Frame statusLeft="INFO" statusRight="5G">
      <Header title="// Info & sicurezza" crumb="◀ indietro" onCrumbClick={() => navigate('/inbox')} />

      <p className="text-[14px] text-ink-dim mb-3">
        come usare Nullum, com'è fatta, e le regole.
      </p>

      <CardLink
        icon="🛡"
        title="La mia sicurezza"
        subtitle="come sei messo ora e cosa puoi migliorare."
        onClick={() => navigate('/sicurezza')}
      />
      <CardLink
        icon="📖"
        title="Manuale & privacy (GDPR)"
        subtitle="come si usa e come proteggiamo i tuoi dati."
        onClick={() => navigate('/info')}
      />
      <CardLink
        icon="📜"
        title="Termini di Servizio"
        subtitle="le regole d'uso e come segnalare un abuso."
        onClick={() => navigate('/termini')}
      />

      <Footer>
        <Btn variant="ghost" onClick={() => navigate('/inbox')}>◀ Inbox</Btn>
      </Footer>
    </Frame>
  );
}
